<template>
    <div class="SatisfactionSurveyTemplate" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>满意度调研模板</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                        <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="120px">
                                <el-form-item label="调研模板名称">
                                    <el-input v-model="queryform.keyword"></el-input>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="AddSatisfactionSurveyTemplate">新增</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :height="Height - 265" :data="tableData" border style="width: 100%">
                    <el-table-column width="100" align="center" prop="id" label="调研模板id" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="title" label="调研模板名称" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="address" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="EditSatisfactionSurveyTemplate(scope.row)">编辑</el-button>
                            <el-button type="text" @click="DelSatisfactionSurveyTemplate(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog :title="title" :visible.sync="SatisfactionSurveyTemplate" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="SatisfactionSurveyTemplate">
                    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item label="调研模板名称" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                    </el-form>
                    <el-row>
                        <el-col style="text-align: right;">
                            <el-button type="primary" @click="AddSatisfactionTemplate">新增</el-button>
                        </el-col>
                    </el-row>
                    <el-table :height="300" :data="SatisfactionTemplateDate" border style="width: 100%;margin-top: 10px;">
                        <el-table-column prop="title" label="调研题目">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.title" placeholder="请输入调研题目"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="title" label="调研题目类型">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.type" placeholder="请选择">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="title" label="是否必填">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.is_must" placeholder="请选择">
                                    <el-option label="是" :value="1">
                                    </el-option>
                                    <el-option label="否" :value="0">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column width="200" align="center" prop="address" label="操作">
                            <template slot-scope="scope">
                                <el-button type="text"  v-show="scope.row.type !== 3" @click="EditItem(scope.row, scope.$index)">编辑调研选项</el-button>
                                <el-button type="text" @click="DelSatisfactionTemplate(scope.row, scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="SatisfactionSurveyTemplate = false">取 消</el-button>
                        <el-button type="primary" @click="SaveSatisfactionSurveyTemplate" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
                <el-dialog title="调研选项" :visible.sync="SatisfactionItem" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="SatisfactionItem">
                    <el-row>
                        <el-col style="text-align: right;">
                            <el-button type="primary" @click="AddSatisfactionItem">新增</el-button>
                        </el-col>
                    </el-row>
                    <el-table :height="300" :data="SatisfactionItemDate" border style="width: 100%;margin-top: 10px;">
                        <el-table-column prop="title" label="调研选项">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.title" placeholder="请输入调研选项"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column width="200" align="center" prop="address" label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" @click="DelSatisfactionItem(scope.row, scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="SatisfactionItem = false">取 消</el-button>
                        <el-button type="primary" @click="SaveSatisfactionItem">确 定</el-button>
                    </div>
                </el-dialog>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "SatisfactionSurveyTemplate",
    data () {
        return {
            url: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            SatisfactionSurveyTemplate: false,
            form: {
                title: ''
            },
            title: '',
            currentPage: 1,
            Size: 20,
            total: 1,
            visible: false,
            queryform: {
                keyword: ''
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            http: https.https,
            preview: false,
            fileList: [],
            rules: {
                title: [
                    { required: true, message: '请输入满意度调研模板名称', trigger: 'blur' }
                ]
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            confirmloding: false,
            SatisfactionTemplateDate: [],
            options: [{
                value: 1,
                label: '单选'
            }, {
                value: 2,
                label: '多选'
            }, {
                value: 3,
                label: '输入框'
            }],
            SatisfactionItemDate: [],
            SatisfactionItem: false,
            index: '',
            Item: {}
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        // 保存调研选项
        SaveSatisfactionItem (e) {
            let Trues = false
            if (this.SatisfactionItemDate.length >= 2) {
                let index = ''
                let True = true
                for (let item in this.SatisfactionItemDate) {
                    if (this.SatisfactionItemDate[item].title === '') {
                        True = false
                        index = Number(item) + 1
                        break
                    }
                }
                if (!True) {
                    this.$message({
                        message: '第' + index + '行调研选项不能为空',
                        type: 'warning'
                    });
                    Trues = false
                } else {
                   Trues = true 
                }
            } else {
                Trues = false
                this.$message({
                    message: '调研选项的数量不能小于2',
                    type: 'warning'
                });
            }
            if (Trues) {
                this.SatisfactionTemplateDate[this.index].SatisfactionItemDate = JSON.parse(JSON.stringify(this.SatisfactionItemDate))
                this.SatisfactionItem = false
            }
        },
        // 删除调研选项
        DelSatisfactionItem (row, index) {
            // console.log(row, index)
             this.$confirm('是否删除该调研选项?', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }).then(() => {
                this.SatisfactionItemDate.splice(index, 1);
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
            })
        },
        // 新增调研选项
        AddSatisfactionItem () {
            let option = {
                title: ''
            }
            if (this.SatisfactionItemDate.length !== 0) {
                let index = ''
                let True = true
                for (let item in this.SatisfactionItemDate) {
                    if (this.SatisfactionItemDate[item].title === '') {
                        True = false
                        index = Number(item) + 1
                        break
                    }
                }
                if (!True) {
                    this.$message({
                        message: '第' + index + '行调研选项不能为空',
                        type: 'warning'
                    });
                } else {
                    this.SatisfactionItemDate.push(option)
                }
            } else {
                this.SatisfactionItemDate.push(option)
            }
        },
        // 编辑调研选项
        EditItem (row, index) {
            console.log(row)
            this.Item = row
            this.index = index
            this.SatisfactionItemDate = JSON.parse(JSON.stringify(row.SatisfactionItemDate))
            this.SatisfactionItem = true
        },
        // 删除调研题目
        DelSatisfactionTemplate (row, index) {
            // console.log(row, index)
             this.$confirm('是否删除该调研题目?', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }).then(() => {
                this.SatisfactionTemplateDate.splice(index, 1);
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
            })
            
        },
        // 新增调研题目
        AddSatisfactionTemplate () {
            let option = {
                title: '',
                type: 1,
                is_must: 1,
                SatisfactionItemDate: []
            }
            if (this.SatisfactionTemplateDate.length !== 0) {
                let index = ''
                let True = true
                for (let item in this.SatisfactionTemplateDate) {
                    if (this.SatisfactionTemplateDate[item].title === '') {
                        True = false
                        index = Number(item) + 1
                        break
                    }
                }
                if (!True) {
                    this.$message({
                        message: '第' + index + '行调研题目不能为空',
                        type: 'warning'
                    });
                } else {
                    this.SatisfactionTemplateDate.push(option)
                }
            } else {
                this.SatisfactionTemplateDate.push(option)
            }
        },
        AddSatisfactionSurveyTemplate () {
            this.SatisfactionSurveyTemplate = true
            this.title = '新增满意度调研模板'
            this.form = {
                title: ''
            }
            this.fileList = []
        },
        handleSizeChange(size) {
            this.Size = size
            this.fullscreenLoading = true
            this.GetSatisfactionSurveyTemplateList()
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetSatisfactionSurveyTemplateList()
        },
        GetSatisfactionSurveyTemplateList (keyword, room) {
            let data = {
                limit: this.Size,
                page: this.currentPage,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
            }
            // data.status = this.queryform.status
            data.keyword = this.queryform.keyword
            this.$store.dispatch('SatisfactionSurveyTemplateListShow', data).then(res => {
                this.fullscreenLoading = false
                this.total = res.something
                this.tableData = res.data
                this.form = {
                    title: ''
                }
                this.visible = false
            })
        },
        Reset () {
           this.$refs['ruleForms'].resetFields();
           this.queryform = {
                keyword: ''
            }
        },
        ConfirmQuery() {
            this.currentPage = 1
            this.GetSatisfactionSurveyTemplateList()
        },
        SaveSatisfactionSurveyTemplate() {
            let that = this;
            let data = JSON.parse(JSON.stringify(this.form));
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            data.admin_id = getAdminId();
            for (let item in this.SatisfactionTemplateDate) {
                this.SatisfactionTemplateDate[item].iOrder = JSON.parse(JSON.stringify(item))
                for (let items in this.SatisfactionTemplateDate[item].SatisfactionItemDate) {
                    this.SatisfactionTemplateDate[item].SatisfactionItemDate[items].iOrder = JSON.parse(JSON.stringify(item))
                }
            }
            data.question = JSON.parse(JSON.stringify(this.SatisfactionTemplateDate))
            for (let item in data.question) {
                data.question[item].options = JSON.stringify(data.question[item].SatisfactionItemDate)
            }
            data.question = JSON.stringify(data.question)
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    let Trues = false
                    let Truess = false
                    if (this.SatisfactionTemplateDate.length !== 0) {
                        let index = ''
                        let True = true
                        for (let item in this.SatisfactionTemplateDate) {
                            if (this.SatisfactionTemplateDate[item].title === '') {
                                True = false
                                index = Number(item) + 1
                                break
                            }
                        }
                        if (!True) {
                            this.$message({
                                message: '第' + index + '行调研题目不能为空',
                                type: 'warning'
                            });
                            Trues = false
                        } else {
                            Trues = true
                            let indexS = ''
                            let TrueS = true
                            for (let item in this.SatisfactionTemplateDate) {
                                if (this.SatisfactionTemplateDate[item].type !== 3 && this.SatisfactionTemplateDate[item].SatisfactionItemDate.length === 0) {
                                    TrueS = false
                                    indexS = Number(item) + 1
                                    break
                                }
                            }
                            if (!TrueS) {
                                this.$message({
                                    message: '第' + indexS + '行调研选项不能为空',
                                    type: 'warning'
                                });
                                Truess = false
                            } else {
                                Truess = true
                            }
                        }
                    } else {
                        this.$message({
                            message: '调研题目不能为空',
                            type: 'warning'
                        });
                        Trues = false
                        Truess = false
                    }
                    if (Trues && Truess) {
                        this.confirmloding = true;
                        that.$store.dispatch('SaveSatisfactionSurveyTemplate', data).then(res => {
                            if (res.flag) {
                                that.$message({
                                    message: '保存成功',
                                    type: 'success'
                                });
                                that.confirmloding = false;
                                that.SatisfactionSurveyTemplate = false;
                                that.fullscreenLoading = true;
                                that.GetSatisfactionSurveyTemplateList();
                            } else {
                                that.$message({
                                    message: res.message,
                                    type: 'warning'
                                });
                            };
                        });
                    } else if (!Trues) {
                        console.log(1)
                    } else if (!Truess) {
                        console.log(2)
                    }
                } else {
                    return false;
                };
            });
            
        },
        EditSatisfactionSurveyTemplate(row) {
            row.ADMIN_ID = getAdminId();
            row.ADMIN_TOKEN = getToken();
            this.$store.dispatch('ShowSurveyTemplateDetail', row).then(res => {
                if (res.flag) {
                    this.form = JSON.parse(JSON.stringify(row))
                    this.SatisfactionSurveyTemplate = true
                    this.title = '编辑满意度调研模板'
                    for (let item in res.something) {
                        res.something[item].is_must=Number(res.something[item].is_must)
                        res.something[item].SatisfactionItemDate=res.something[item].options
                    }
                    this.SatisfactionTemplateDate = JSON.parse(JSON.stringify(res.something))
                } else {
                }
            })
        },
        DelSatisfactionSurveyTemplate(row) {
            this.$confirm('是否删除该满意度调研模板？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId();
                row.ADMIN_TOKEN = getToken();
                this.$store.dispatch('DelSatisfactionSurveyTemplate', row).then(res => {
                     if (res.flag) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        })
                        this.fullscreenLoading = true
                        this.GetSatisfactionSurveyTemplateList()
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                })
            }).catch(() => {
            })
        }
    },
    created() {
        this.fullscreenLoading = true
        this.GetSatisfactionSurveyTemplateList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.SatisfactionSurveyTemplate {
    width: 100%;
}
.SatisfactionSurveyTemplate .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.SatisfactionSurveyTemplate .el-header .el-row .el-col h2 {
    text-align: center;
}
.SatisfactionSurveyTemplate .el-header .el-row .el-col {
    text-align: center;
}
.SatisfactionSurveyTemplate .el-header .el-row .el-col:last-child {
    text-align: right;
}
.SatisfactionSurveyTemplate .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.SatisfactionSurveyTemplate .el-main .SatisfactionSurveyTemplate .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
}
.SatisfactionSurveyTemplate .el-main .SatisfactionSurveyTemplate .el-dialog__body .cell {
    padding: 0px;
}
.SatisfactionSurveyTemplate .el-main .SatisfactionSurveyTemplate .el-dialog__body .cell input {
    border: 0px;
}
.SatisfactionSurveyTemplate .el-main .SatisfactionItem .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
}
.SatisfactionSurveyTemplate .el-main .SatisfactionItem .el-dialog__body .cell {
    padding: 0px;
}
.SatisfactionSurveyTemplate .el-main .SatisfactionItem .el-dialog__body .cell input {
    border: 0px;
}
.SatisfactionSurveyTemplate .el-main .SatisfactionSurveyTemplate .el-dialog__body .el-form-item .el-select, .SatisfactionSurveyTemplate .el-main .SatisfactionSurveyTemplate .el-dialog__body .el-form-item .el-date-editor {
    width: 100%;
}
</style>
